module.exports = __webpack_public_path__ + "static/media/feedback.fd8faaa8.svg";